<template>
  
</template>

<script>
export default {

}
</script>

<style>

</style>
<script>
import { cardActivate } from "@/api/card";
export default {
  computed: {
    device() {
      return this.$store.state.app.device;
    },
    username(){
      return this.$store.state.user.fullname;
    }
  },
  data(){
    return {
      cardID: ""
    }
  },
  methods:{

    openDialog(cardID){
      this.cardID = cardID;
      this.$confirm('Activate Card. Continue?', 'Confirm', {
          confirmButtonText: 'ACTIVATE',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.submitActivate();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Activate Card canceled'
          });          
        });
    },

    submitActivate(){
      let data = {
        "user": this.username,
        "terminalLocation": "GB"
      }
       cardActivate(this.cardID, data).then(({result}) =>{
        if(result){
          this.$notify({
            title: 'Success',
            message: `Activate Card successfully`,
            type: 'success',
            duration: 2000
          });
          this.$emit('submited')
        }
      })
    },
    handleClose(){
    }
  }
}
</script>

<style>

</style>